import { axiosInstance } from "./";

const getApplicantsList = async (params) =>
  await axiosInstance.get("/users", { params });

const updateApplicant = async ({ id, params }) =>
  await axiosInstance.patch(`/users/${+id}`, params);

const getApplicant = async (id) => await axiosInstance.get(`/users/${id}`);
const updateApplicantProfile = async ({ id, data }) =>
  await axiosInstance.patch(`/users/${+id}/update_profile`, data);

const getEligibleApplicantsList = async ({ id, params }) =>
  await axiosInstance.get(`/events/${id}/eligible_users`, { params });

const updateApplicantDeduction = async ({ id, event_id, params }) =>
  await axiosInstance.post(
    `/events/${+event_id}/users/${id}/add_manual_deduction`,
    params
  );

const updateApplicantReward = async ({ id, event_id, params }) =>
  await axiosInstance.post(
    `/events/${+event_id}/users/${id}/add_reward`,
    params
  );

const updateApplicantRevertReward = async ({ id, event_id }) =>
  await axiosInstance.patch(`/events/${+event_id}/users/${id}/revert_reward`);

const updateApplicantRevertDeduction = async ({ id, event_id }) =>
  await axiosInstance.patch(
    `/events/${+event_id}/users/${id}/revert_manual_deduction`
  );

const promoteApplicantRole = async ({ user_id }) =>
  await axiosInstance.patch(`/roles/promote_user_to_admin`, { user_id });

const demoteApplicantRole = async ({ user_id }) =>
  await axiosInstance.patch(`/roles/demote_user_from_admin`, { user_id });

const getCheckListingApplicantsList = async (payload) =>
  await axiosInstance.get(`/users/list_profiles`, {
    params: { user_ids: payload },
  });

export {
  getApplicantsList,
  getApplicant,
  updateApplicant,
  getEligibleApplicantsList,
  updateApplicantProfile,
  updateApplicantDeduction,
  updateApplicantReward,
  updateApplicantRevertReward,
  updateApplicantRevertDeduction,
  promoteApplicantRole,
  demoteApplicantRole,
  getCheckListingApplicantsList,
};
